import denominationCreateComponent from './denomination.create.component';
import './denomination.create.scss';

let denominationCreateModule = angular.module('denominationcreate', [
  ])

  .component('denominationcreate', denominationCreateComponent)

  .name;

export default denominationCreateModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/denomination/create/index.js